import * as React from 'react';
import styled, {css} from "styled-components";

interface ItemProps {
  year: number;
  items: ItemElement[];
}

interface ItemElement {
  title: string;
  description?: string;
  lastElement?: boolean;
}

const Year = styled.div`
  min-width: 45px;
`

const Content = styled.div`
  position: relative;
  padding-left: 45px;
`
const Box = styled.div<{withBefore: boolean}>`
  position: relative;
  padding-bottom: 16px;

  &::before {
    ${({withBefore}) => withBefore && css`
      content: '';
      display: block;
      position: absolute;
      left: -34px;
      top: 0;
      bottom: 0;
      width: 1px;
      background-color: #29292B;

      @media screen and (max-width: 550px) {
        top: 7px;
        bottom: -7px;
        left: -19px;
      }
    `}
  }
`

const Title = styled.div`
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -50px;
    top: 0;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    border: 1px solid #29292B;
    background-color: white;

    @media screen and (max-width: 550px) {
      left: -25px;
      top: 7px;
      height: 11px;
      width: 11px;
    }
  }
`

const Description = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #67686B;
`

const Container = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 56px;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0.01em;

  @media screen and (max-width: 550px) {
    gap: 10px;
    
    ${Content} {
      padding-left: 30px;
    }
  }
`;

/**
 * render landing page tariffs section card
 * @constructor
 */
export default function Item(props: ItemProps): React.ReactElement {

  function renderItems() {
    return props.items.map(item => (
      <Box key={item.title} withBefore={!Boolean(item.lastElement)}>
        <Title>{item.title}</Title>
        <Description>{item.description}</Description>
      </Box>
    ))
  }

  return (
    <Container>
      <Year>{props.year}</Year>
      <Content>
        {renderItems()}
      </Content>
    </Container>
  );
}
